import React, { FC } from 'react';
import { useIntl } from 'react-intl';
// import Link from 'next/link';

import {
  Box,
  Text,
  VStack,
  Flex,
  SimpleGrid,
  Container,
  Heading,
} from '@chakra-ui/react';

import BaseImage from '../Base/BaseImage/BaseImage';

import {
  Column1,
  Column2,
  Column3,
  Column4,
  Column5,
} from '../../constants/data/footer';

const Footer: FC = () => {
  const { formatMessage } = useIntl();
  const f: (id: string) => string = (id: string) => formatMessage({ id });

  const SectionMain = () => (
    <Box px='5' py={['8', '16']} bgColor={'imColor.primary-light'}>
      <Container maxW='5xl'>
        <Box>
          <SimpleGrid columns={[1, 2, 3, 5]} spacing={10}>
            <VStack align='start' spacing={'0.4rem'}>
              <Heading as='h4' size='md' textTransform='uppercase' mb='1'>
                {f('compare')}
              </Heading>
              {Column1.map(({ title, link }) => (
                <Box as={'a'} href={link} key={title}>
                  <Text as={'button'}>{title}</Text>
                </Box>
              ))}
            </VStack>
            <VStack align='start' spacing={'0.4rem'}>
              <Heading as='h4' size='md' textTransform='uppercase' mb='1'>
                {f('insurance')} {f('companies')}
              </Heading>
              {Column2.map(({ title, link }) => (
                <Box as={'a'} href={link} key={title}>
                  <Text as={'button'}>{f(title)}</Text>
                </Box>
              ))}
            </VStack>
            <VStack align='start' spacing='0.4rem'>
              <Heading as='h4' size='md' textTransform='uppercase' mb='1'>
                {f('insurance')}
              </Heading>
              {Column3.map(({ title, link }) => (
                <Box as={'a'} href={link} key={title}>
                  <Text as={'button'}>{f(title)}</Text>
                </Box>
              ))}
            </VStack>
            <VStack align='start' spacing={'0.4rem'}>
              <Heading as='h4' size='md' textTransform='uppercase' mb='1'>
                {f('aboutUs')}
              </Heading>
              {Column4.map(({ title, link }) => (
                <Box as={'a'} href={link} key={title}>
                  <Text as={'button'}>{f(title)}</Text>
                </Box>
              ))}
            </VStack>
            <VStack align='start' spacing={'0.4rem'}>
              <Heading as='h4' size='md' textTransform='uppercase' mb='1'>
                {f('guides')}
              </Heading>
              {Column5.map(({ title, link }) => (
                <Box as={'a'} href={link} key={title}>
                  <Text as={'button'}>{f(title)}</Text>
                </Box>
              ))}
            </VStack>
          </SimpleGrid>
        </Box>
      </Container>
    </Box>
  );

  const SectionBottom = () => (
    <Box borderTop='2px' borderColor='lightgray' p='5'>
      <VStack align='stretch' spacing='3'>
        <Box>
          <Flex justify='center'>
            <Box
              as={'a'}
              href={'/'}
              w='270px'
              aria-label={'Insurance Market Logo'}
            >
              <BaseImage
                src={'/assets/img/logo/logowithrating.png'}
                alt={'Insurance Market'}
                dimensions={[270, 45]}
              />
            </Box>
            <Box
              as={'a'}
              href={'https://afia.ae'}
              w='270px'
              aria-label={'Afia Logo'}
            >
              <BaseImage
                src={'/assets/img/logo/logo-afia.png'}
                alt={'Afia Insurance'}
                dimensions={[270, 45]}
              />
            </Box>
          </Flex>
        </Box>
        <Box textAlign={'center'}>
          <Text fontSize={'xs'} mb='2'>
            {f('footerTagLine1')}
          </Text>
          <Text fontSize={'xs'}>{f('footerTagLine2')}</Text>
        </Box>
      </VStack>
    </Box>
  );

  return (
    <Box pb={{ base: 55, lg: 0 }}>
      <SectionMain />
      <SectionBottom />
    </Box>
  );
};

export default Footer;
